import React from 'react';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import ModalManager from '../modal-manager';
import { open } from '../modal-container/ModalContainer';
import PictureViewer from '../picture/PictureViewer';
import { $l } from '../locale-context';
export default function preview(props, modalProps) {
    const customizedPrefixCls = getProPrefixCls('picture-viewer', props.prefixCls);
    open({
        key: ModalManager.getKey(),
        className: `${customizedPrefixCls}-modal`,
        border: false,
        title: $l('Modal', 'preview_picture'),
        footer: null,
        destroyOnClose: true,
        movable: false,
        closable: true,
        style: { width: 'auto' },
        fullScreen: true,
        children: (React.createElement(PictureViewer, Object.assign({ prefixCls: customizedPrefixCls }, props))),
        ...modalProps,
    });
}
